// Module
var code = "<div class=\"notifire-list-close js-close-notification\" title=\"<@- title @>\">\n    <span class=\"notifire-list-close__x\">\n        <svg class=\"svg-icon\">\n            <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svgicon--close\"></use>\n        </svg>\n    </span>\n</div>";
// Exports
export default code;